import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";

import Page from "./Page";
import Dashboard from "../dashboard/Dashboard";
import NavToolbar from "../layout/NavToolbar";

const Home = () => {
  const navigate = useNavigate();

  const theme = useTheme();

  const handleToolBarClick = (item) => {
    switch (item) {
      case "syncDashboard":
        navigate("/syncdashboard");
        break;

      case "surveyDashboard":
        navigate("/surveymetrics");
        break;

      case "orderDashboard":
        navigate("/orderdashboard");
        break;

      case "clientDashboard":
        navigate("/clientdashboard");
        break;

      case "repDashboard":
        navigate("/repdashboard");
        break;
    }
  };

  return (
    <>
      <Page
        pageName="home"
        includeToolbar={true}
        onToolItemClick={handleToolBarClick}
        items={[
          { name: "syncDashboard", iconName: "CloudSync" },
          { name: "surveyDashboard", iconName: "Assignment" },
          { name: "orderDashboard", iconName: "ShoppingCart" },
          { name: "clientDashboard", iconName: "Business" },
          { name: "repDashboard", iconName: "People" },
        ]}
      >
        <Dashboard />
      </Page>
    </>
  );
};

export default Home;
